// extracted by mini-css-extract-plugin
module.exports = {"root":"file-content_root__35RS2","disabled":"file-content_disabled__Fj8aV"};